import { render, staticRenderFns } from "./SubSetting3.vue?vue&type=template&id=3d5c197f"
import script from "./SubSetting3.vue?vue&type=script&lang=js"
export * from "./SubSetting3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports